.button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  position: fixed;
  transform: translate(-50%, 50%);
  left: 50%;
  bottom: 2lh;
  z-index: 1;
  padding: 0.5rem 1rem 0.5rem 0.75rem;
  color: var(--fg);
  background-color: hsl(var(--bg-hsl), 0.5);
  backdrop-filter: blur(8px);
  border: 1px solid hsl(var(--fg-hsl-dim), 0.5);
  box-shadow: 0 3px 6px 1px var(--bg-dim);
  transition: all 0.5s ease-in-out;
}

@media (hover: hover) {
  .button:hover {
    color: var(--fg-lit);
    background-color: hsl(var(--bg-hsl-lit), 0.7);
    border-color: hsl(var(--fg-hsl-dim), 0.7);
  }
}
